import React, { useEffect, useState } from 'react'
import Modal from "../../modal/Modal";
import { Button } from "ui-kit.aspentech.com/dist/components";
import "./BriefCaseModal.scss";

export const BriefCaseModal = () => {
    const [showModal, setShowModal] = useState(window?.__MODAL_OPENED || false);
    
    const closeModal = () => {
        window.__MODAL_OPENED = false;
        setShowModal(false);
    }

    useEffect(() => {
        const handleToggle = () => {
            setShowModal(window.__MODAL_OPENED || false);
        };

        window.addEventListener("openModal", handleToggle);
        return () => window.removeEventListener("openModal", handleToggle);

    }, []);

    return (
        <>
            {showModal && (
                <div className='msg-modal'>
                    <Modal title="Reminder: 'My Briefcase' features are Temporarily Disabled" onClose={closeModal} scrollable={true} fixedTitle={false}>
                        <div className="modal-content">
                            <p className='title'></p>
                            <p className='subtitle'>'<strong>My Briefcase</strong>' features are disabled from November 2025 until the end of February 2026 while we move SRC into Emerson.</p>
                            <div className="modal-button">
                            <Button onClick={closeModal}>Close</Button>
                            </div>
                        </div>
                    </Modal>
                </div>
            )}
        </>

    );
}
